import { Alert, Typography } from '@mui/material'
import { SnackbarContent, SnackbarKey, SnackbarMessage } from 'notistack'
import React from 'react'
import { Severity } from 'src/Api/Enum/Snackbar'

interface IProps {
    id: SnackbarKey
    message: SnackbarMessage,
    severity: Severity
}

export const CustomSnackbar = React.forwardRef<HTMLDivElement, IProps>((props, ref) => {
    const { id, message, severity, ...other } = props

    return (
        <SnackbarContent ref={ref} >
            <Alert severity={severity} sx={{ width: '100%', alignItems: 'center' }}>
                <Typography variant="body1"> {message} </Typography>
            </Alert>
        </SnackbarContent>
    )
})